export default class CustomField {
  id: string;

  name: string;

  path: string;

  status: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.name = obj.name;
    this.path = obj.path;
    this.status = obj.status;
  }

  static of(obj: any): CustomField {
    return new CustomField(obj || {});
  }

  static ofList(obj: any): CustomField[] {
    return (obj || []).map((value: any) => this.of(value));
  }
}
